import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { HeartPulse, Sparkles, Ear, Bone, Brain, Eye, Activity, Droplet, Flower2, Stethoscope } from "lucide-react";

const ICON = {
  general_practice: <Stethoscope size={22}/>,
  cardiology: <HeartPulse size={22}/>,
  dermatology: <Sparkles size={22}/>,
  ent: <Ear size={22}/>,
  orthopaedics: <Bone size={22}/>,
  gynaecology: <Flower2 size={22}/>,
  neurology: <Brain size={22}/>,
  gastroenterology: <Activity size={22}/>,
  endocrinology: <Droplet size={22}/>,
  urology: <Droplet size={22}/>,
  ophthalmology: <Eye size={22}/>,
  psychiatry: <Brain size={22}/>,
};

export default function Specialists() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/specialties").then(r => setItems(r.data)); }, []);
  return (
    <div className="cm-container py-12">
      <div className="mb-8">
        <div className="cm-eyebrow mb-2">Specialties</div>
        <h1 className="cm-h2">Direct access to specialists.</h1>
        <p className="cm-body mt-2 max-w-2xl">Consultants across 10+ specialties. No GP referral required. £70 per specialist consultation.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(s => (
          <Link key={s.key} to={`/find-care?specialty=${s.key}`} className="cm-card group" data-testid={`specialty-${s.key}`}>
            <div className="w-11 h-11 rounded-lg bg-[#ebf3fc] text-[#4a90d9] flex items-center justify-center mb-3 group-hover:bg-[#4a90d9] group-hover:text-white transition-colors">
              {ICON[s.key] || <Stethoscope size={22}/>}
            </div>
            <div className="font-semibold text-[#1a2b4a]">{s.name}</div>
            <div className="text-xs text-[#475569] mt-1">{s.is_specialist ? "Specialist £70" : "General £50"}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
